import useResource from 'app/hooks/useResource';
import {
    updateAccessCodePage
} from 'app/services/accessCodePages';

const useAccessCodeMetaDataForm = (props) => {
    const { formIsOpen, onFormClose, onEdit, onFormSubmit } = useResource({ updateResource: updateAccessCodePage, disableShowOnCreate: true });

    return { formIsOpen, onFormClose, onEdit, onFormSubmit };
}

export default useAccessCodeMetaDataForm;